<div class="flex">
  <main class="flex-1" [ngClass.lt-md]="{ mobile: true }">
    <div class="flex flex-col md:flex-row mb-10">
      <div class="w-auto md:w-full">
        <h1>Good {{ greetingToD }}, {{ user.first_name }}</h1>
        <div class="text-xl mt-3">Here is what's happening with your business today</div>
      </div>
    </div>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'dashboard'"></sbnb-helptext-wrapper>

    <ng-container *ngIf="counts$ | async as counts">
      <div class="mb-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
        <div *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async" class="min-w-40">
          <a class="headline__container" [routerLink]="['/inbox/segments/2112c9a9-5c2e-4859-b9fe-e66ac64c188d']">
            <h1>{{ counts.inquiries }}</h1>
            <span class="headline__secondary">Inquiries</span>
          </a>
        </div>
        <div *ngIf="perms$.hasAccessTo(Features.PERM_INBOX) | async" class="min-w-40">
          <a class="headline__container" [routerLink]="['/inbox/segments/aaa8b5fc-a113-425c-bf7f-f08a6cc86bb7']">
            <h1>{{ counts.requests }}</h1>
            <span class="headline__secondary">Requests to book</span>
          </a>
        </div>
        <div *ngIf="perms$.hasAccessTo(Features.PERM_GUEST_EXPERIENCE) | async" class="min-w-40">
          <a class="headline__container" [routerLink]="['/gx/overview']">
            <h1>{{ counts.scheduled }}</h1>
            <span class="headline__secondary">Scheduled messages</span>
          </a>
        </div>
        <div
          *ngIf="
            (perms$.hasAccessTo(Features.PERM_TASKS_UPDATE_ALL) | async) &&
            (perms$.hasAccessTo(Features.PERM_OPERATIONS) | async)
          "
          class="min-w-40">
          <a class="headline__container" [routerLink]="['/operations/overview']">
            <h1>{{ counts.tasks }}</h1>
            <span class="headline__secondary">Unassigned tasks</span>
          </a>
        </div>
      </div>
    </ng-container>

    <mat-tab-group class="dashboard__tabs">
      <mat-tab label="Check-ins">
        <sbnb-loading-spinner *ngIf="checkinsLoading" class="block mt-8"></sbnb-loading-spinner>

        <div *ngIf="!checkinsLoading && (!checkins || checkins?.length === 0)" class="m-5">
          <sbnb-no-items icon="check-in" text="You don't have any upcoming check-ins at the moment"></sbnb-no-items>
        </div>

        <ng-container *ngIf="!checkinsLoading">
          <div class="dashboard__tab-innner" *ngIf="checkins && checkins.length > 0">
            <a
              *ngFor="let checkin of checkins"
              class="checkin__container flex gap-4 items-center"
              (click)="openDetailsModal(checkin.thread_uuid)">
              <!-- Guest details -->
              <div class="flex items-center gap-4 w-8/12 md:w-4/12">
                <img
                  class="border-radius-50 w-10 h-10"
                  [src]="checkin.guest_picture"
                  onerror="this.src='/assets/images/profile-default.png'" />

                <div class="flex flex-col">
                  <!-- Guest name -->
                  <div class="strong w-full">{{ checkin.guest }}</div>

                  <!-- Property name on mobile-->
                  <span class="block md:hidden text__small truncate">{{ checkin.listing.property_name }}</span>
                </div>
              </div>

              <!-- Reservation details -->
              <div class="hidden md:flex gap-3 w-3/12 items-center">
                <img
                  *ngIf="checkin.channel"
                  class="checkin__icon"
                  [src]="'/assets/iconography/' + (checkin.channel | lowercase) + '.svg'" />

                <span class="text__xsmall night-lighter">{{ checkin.code }}</span>
              </div>

              <!-- Property details -->
              <div class="hidden md:flex w-3/12 items-center gap-3">
                <img *ngIf="checkin.listing.image" class="rounded w-8 h-6 shrink-0" [src]="checkin.listing.image" />
                <span class="text__small">{{ checkin.listing.property_name }}</span>
              </div>

              <!-- Check in time -->
              <div class="flex w-4/12 md:w-2/12 gap-2 justify-end items-center">
                <span class="text__small" [matTooltip]="checkin.checkin_tooltip">
                  {{ checkin.checkin_label }}
                </span>
                <sbnb-icon icon="time" [size]="16" class="shrink-0 text-night"></sbnb-icon>
              </div>
            </a>
          </div>

          <hospitable-pagination
            *ngIf="
              checkinsPagination &&
              !loading &&
              (checkinsPagination.page_numbers.total_pages > 1 ||
                checkinsPagination._links?.next ||
                checkinsPagination._links?.prev)
            "
            class="mt-4"
            [pagination]="checkinsPagination"
            (pageChanged)="handlePageChanged($event, 'checkins')"
            (cursorChanged)="handleCursorChanged($event, 'checkins')"></hospitable-pagination>
        </ng-container>
      </mat-tab>

      <mat-tab label="Check-outs">
        <sbnb-loading-spinner *ngIf="checkoutsLoading" class="block mt-8"></sbnb-loading-spinner>

        <div *ngIf="!checkoutsLoading && (!checkouts || checkouts?.length === 0)" class="m-5">
          <sbnb-no-items icon="check-out" text="You don't have any upcoming check-outs at the moment"></sbnb-no-items>
        </div>

        <ng-container *ngIf="!checkoutsLoading">
          <div class="dashboard__tab-innner" *ngIf="checkouts && checkouts.length > 0">
            <a
              *ngFor="let checkout of checkouts"
              class="checkin__container flex gap-4 items-center"
              (click)="openDetailsModal(checkout.thread_uuid)">
              <!-- Guest details -->
              <div class="flex items-center gap-4 w-8/12 md:w-4/12">
                <img
                  class="border-radius-50 w-10 h-10"
                  [src]="checkout.guest_picture"
                  onerror="this.src='/assets/images/profile-default.png'" />

                <div class="flex flex-col">
                  <!-- Guest name -->
                  <div class="strong w-full">{{ checkout.guest }}</div>

                  <!-- Property name on mobile-->
                  <span class="block md:hidden text__small truncate">{{ checkout.listing.property_name }}</span>
                </div>
              </div>

              <!-- Reservation details -->
              <div class="hidden md:flex gap-3 w-3/12 items-center">
                <img
                  *ngIf="checkout.channel"
                  class="checkin__icon"
                  [src]="'/assets/iconography/' + (checkout.channel | lowercase) + '.svg'" />

                <span class="text__xsmall night-lighter">{{ checkout.code }}</span>
              </div>

              <!-- Property details-->
              <div class="hidden md:flex w-3/12 items-center gap-3">
                <img *ngIf="checkout.listing.image" class="rounded w-8 h-6 shrink-0" [src]="checkout.listing.image" />
                <span class="text__small">{{ checkout.listing.property_name }}</span>
              </div>

              <!-- Check in time -->
              <div class="flex w-4/12 md:w-2/12 gap-2 justify-end items-center">
                <span class="text__small" [matTooltip]="checkout.checkin_tooltip">
                  {{ checkout.checkout_label }}
                </span>
                <sbnb-icon icon="time" [size]="16" class="shrink-0 text-night"></sbnb-icon>
              </div>
            </a>
          </div>

          <hospitable-pagination
            *ngIf="
              checkoutsPagination &&
              !loading &&
              (checkoutsPagination.page_numbers.total_pages > 1 ||
                checkoutsPagination._links?.next ||
                checkoutsPagination._links?.prev)
            "
            class="mt-4"
            [pagination]="checkoutsPagination"
            (pageChanged)="handlePageChanged($event, 'checkouts')"
            (cursorChanged)="handleCursorChanged($event, 'checkouts')"></hospitable-pagination>
        </ng-container>
      </mat-tab>

      <mat-tab label="Tasks" *ngIf="canViewTasks">
        <sbnb-loading-spinner *ngIf="tasksLoading" class="block mt-8"></sbnb-loading-spinner>

        <div *ngIf="!tasksLoading && (!tasks || tasks?.length === 0)" class="m-5">
          <sbnb-no-items icon="task" text="You don't have any tasks at the moment"></sbnb-no-items>
        </div>

        <ng-container *ngIf="!tasksLoading">
          <div class="dashboard__tab-innner" *ngIf="tasks && tasks.length > 0">
            <div
              *ngFor="let task of tasks"
              class="checkin__container checkin__container-task flex items-center gap-5"
              #assignMenuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="assignMenu"
              (menuOpened)="selectedTask = task"
              (menuClosed)="checkListToggleDashboard()">
              <!-- Basic task details -->
              <div class="w-8/12 md:w-4/12 flex items-center">
                <div class="flex flex-col">
                  <div class="flex items-center gap-4">
                    <strong class="truncate" [matTooltip]="task.name">
                      {{ task.task_rule ? task.task_rule.name : task.task_type_string }}
                    </strong>

                    <span class="overview__effort text__xsmall strong min-w-16 text-center">
                      {{ task.duration }}
                    </span>
                  </div>

                  <span *ngIf="task.property" class="block md:hidden text-sm truncate">
                    {{ task.property.name }}
                  </span>

                  <div class="block md:hidden">
                    <ng-container *ngTemplateOutlet="taskAssignmentDetails"></ng-container>
                  </div>
                </div>
              </div>

              <!-- Property details -->
              <div class="hidden md:flex w-3/12 gap-2">
                <ng-container *ngIf="task.property">
                  <img class="rounded w-8 h-6 shrink-0" [src]="task.property.picture" width="24px" height="20px" />
                  <span class="text-sm truncate">{{ task.property.name }}</span>
                </ng-container>
              </div>

              <div class="hidden md:block w-3/12">
                <ng-container *ngTemplateOutlet="taskAssignmentDetails"></ng-container>
              </div>

              <!-- Assignment details -->
              <ng-template #taskAssignmentDetails>
                <div *ngIf="!task.teammate && canEditAllTasks" class="flex gap-2 items-center">
                  <span class="text-sm">Unassigned</span>
                  <sbnb-button class="hidden md:block" type="secondary" size="mini">Assign</sbnb-button>
                </div>

                <div
                  *ngIf="task.teammate"
                  [class.clickable]="task.computed.can_edit"
                  [class.pointer-events]="!task.computed.can_edit"
                  class="flex items-center">
                  <sbnb-team-icon class="hidden md:flex w-8" [member]="task.teammate"></sbnb-team-icon>
                  <span class="text-sm truncate">{{ task.teammate.name }}</span>
                </div>
              </ng-template>

              <!-- Task start time -->
              <div class="flex w-4/12 md:w-2/12 gap-2 justify-end items-center">
                <span class="text__small" [matTooltip]="task.start_date_tooltip">
                  {{ task.start_date_label }}
                </span>
                <sbnb-icon icon="time" [size]="16" class="shrink-0 text-night"></sbnb-icon>
              </div>
            </div>

            <mat-menu #assignMenu="matMenu" class="filters__cdk-menu filters__cdk-menu-320 task-menu">
              <sbnb-menu-task-assign
                #menuTaskAssign
                [task]="selectedTask"
                (updatedTask)="taskAssigned($event)"
                (taskDeleted)="removeTask($event)"></sbnb-menu-task-assign>
            </mat-menu>
          </div>

          <hospitable-pagination
            *ngIf="
              tasksPagination &&
              !loading &&
              (tasksPagination.page_numbers.total_pages > 1 ||
                tasksPagination._links?.next ||
                tasksPagination._links?.prev)
            "
            class="mt-4"
            [pagination]="tasksPagination"
            (pageChanged)="handlePageChanged($event, 'tasks')"
            (cursorChanged)="handleCursorChanged($event, 'tasks')"></hospitable-pagination>
        </ng-container>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>
